import { render, staticRenderFns } from "./CustomerStatusBar.vue?vue&type=template&id=487e064a&scoped=true"
import script from "./CustomerStatusBar.vue?vue&type=script&lang=js"
export * from "./CustomerStatusBar.vue?vue&type=script&lang=js"
import style0 from "./CustomerStatusBar.vue?vue&type=style&index=0&id=487e064a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487e064a",
  null
  
)

export default component.exports